import React, {
  useContext, useState, useEffect,
} from 'react'
import { Box } from '@usap/uicomponents'
import { ReturnItemContext } from '../../../../../contexts/ReturnItemContextProvider'
import { SelectedItemsContext } from '../../../../../contexts/SelectedItemsContextProvider'
import ReturnStatus from '../../../ReturnStatus'
import { useReturnStatusData, useEtaToshow, useManageComputation } from './hooks'
import { partsWithVideos } from './constant'
import ReturnItemDetail from './component/ItemDetail'
import {
  ParentSku, ItemImage, ComputeQtyCheckbox, DisplayVideoLightBox,
} from './component'
import { getContainerBorder, handleItemCheckboxChange } from './utils'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import RMAReturnItemInfoWMO from './RMAReturnItemInfoWMO'

const RMAReturnItemInfo = props => {
  const {
    showTabs,
    isDesktop,
    imageHeight,
    removeQtySelect,
    submitSelect = false,
    isBot,
    selectedPart,
    isMultiplePart,
    Link,
    buttonLabel,
    setReturnQuantity,
    setDisplayReturnDetails,
    setItemImage,
    setReturnDetailsData,
    creditStatus,
    returnRequestStatus,
    orderInfo = {},
    parts,
    eligibleStatuses,
    setErrorSteps,
    setPartsSelection,
    ikey = 0,
    OpenChatHandler,
    multipleItemsPresent,
    partReturnEligibilityList,
    setPartReturnEligibilityList,
  } = props

  const {
    order_item_id: itemOrderId,
    order_item_status: orderItemStatus = '',
    parentSku,
    qty: orderQty,
    available_return_qty: qty,
    brandText,
    sku: partNumber,
    list: itemPrice,
    sku_title: skuTitle,
    productText,
    ImageURL: imageSrc,
    returnQty: returnQuantity,
    returnRequest = {},
  } = parts

  const { setReturnQty, returnItemQty } = useContext(ReturnItemContext)
  const { orderItems, setOrderItems } = useContext(SelectedItemsContext)

  const imageText = skuTitle || `${brandText} ${partNumber} ${productText}`

  const imageUrlSrc = setItemImage(imageSrc, partNumber)

  const returnStatusData = useReturnStatusData({
    orderInfo,
    returnRequest,
    returnRequestStatus,
    creditStatus,
  })
  const [showVideo, setShowVideo] = useState(false)
  const {
    displayNull, showCheckBox, itemTotal, qtyRange, setSelectedQty,
    hasEligibleStatus, hasRMA, eligibleRMA, qtyToCompute, itemPriceParsed, selectedQty,
  } = useManageComputation({
    returnQuantity,
    qty,
    selectedPart,
    partNumber,
    returnRequest,
    eligibleStatuses,
    orderItemStatus,
    buttonLabel,
    submitSelect,
    orderQty,
    itemPrice,
  })

  const getOrderIndexContext = id => orderItems.findIndex(product => product.order_item_id === id)

  /* Method used when unchecking selection for returns */
  const removeReturnItem = itemId => {
    const foundIndex = getOrderIndexContext(itemId)
    orderItems.splice(foundIndex, 1)
    return foundIndex
  }

  const handleChange = event => {
    handleItemCheckboxChange({
      event,
      setErrorSteps,
      removeReturnItem,
      setOrderItems,
      orderItems,
      parts,
    })
  }

  const etaToShow = useEtaToshow({
    parts, isDesktop, showTabs, hasEligibleStatus, hasRMA, OpenChatHandler,
  })

  const handleQtyChange = quantity => {
    if (orderItems.length) {
      let indexData = 0
      orderItems.forEach(itemData => {
        if (itemData.order_item_id === itemOrderId) {
          orderItems[`${indexData}`].returnQty = quantity
        }
        indexData += 1
      })
    }

    setReturnQuantity(parseInt(quantity, 10))
    setSelectedQty(parseInt(quantity, 10))
    setReturnQty(parseInt(quantity, 10))
  }

  useEffect(() => {
    if (!returnQuantity && selectedPart && orderItems.length > 0) {
      setPartsSelection(orderItems)
    }
  }, [returnQuantity, selectedPart, orderItems, setPartsSelection])

  if (displayNull) return null

  const isWmoEnabled = useWmoEnabled()

  if(isWmoEnabled) {
    return (
      <RMAReturnItemInfoWMO 
        {...props}
        handleQtyChange={handleQtyChange}
        etaToShow={etaToShow}
        handleChange={handleChange}
        showVideo={showVideo}
        setShowVideo={setShowVideo}
        returnStatusData={returnStatusData}
        imageText={imageText}
        imageUrlSrc={imageUrlSrc}
        orderItems={orderItems}
        returnItemQty={returnItemQty}
        displayNull={displayNull}
        showCheckBox={showCheckBox}
        itemTotal={itemTotal}
        qtyRange={qtyRange}
        eligibleRMA={eligibleRMA} 
        qtyToCompute={qtyToCompute}
        itemPriceParsed={itemPriceParsed} 
        selectedQty={selectedQty}
        multipleItemsPresent={multipleItemsPresent}
        partReturnEligibilityList={partReturnEligibilityList}
        setPartReturnEligibilityList={setPartReturnEligibilityList}
      />
    )
  }

  return (
    <>
      <Box
        pad="small"
        justify="start"
        direction="column"
        round="6px"
        style={{ marginBottom: removeQtySelect ? 0 : 20 }}
        border={getContainerBorder(removeQtySelect)}
      >
        <Box direction="row">
          <ComputeQtyCheckbox
            isMultiplePart={isMultiplePart}
            itemOrderId={itemOrderId}
            showCheckBox={showCheckBox}
            handleChange={handleChange}
            qtyToCompute={qtyToCompute}
          />
          <ItemImage
            imageHeight={imageHeight}
            itemOrderId={itemOrderId}
            eligibleRMA={eligibleRMA}
            imageUrlSrc={imageUrlSrc}
            imageText={imageText}
          />
          <ReturnItemDetail
            isDesktop={isDesktop}
            orderItems={orderItems}
            eligibleRMA={eligibleRMA}
            brandText={brandText}
            selectedPart={selectedPart}
            partNumber={partNumber}
            showTabs={showTabs}
            removeQtySelect={removeQtySelect}
            ikey={ikey}
            qtyRange={qtyRange}
            qtyToCompute={qtyToCompute}
            handleQtyChange={handleQtyChange}
            returnItemQty={returnItemQty}
            itemPriceParsed={itemPriceParsed}
            selectedQty={selectedQty}
            showCheckBox={showCheckBox}
            imageText={imageText}
            itemTotal={itemTotal}
            parentSku={parentSku}
            etaToShow={etaToShow}
            returnStatusData={returnStatusData}
            orderInfo={orderInfo}
            Link={Link}
            creditStatus={creditStatus}
            returnRequestStatus={returnRequestStatus}
            setReturnDetailsData={setReturnDetailsData}
            setDisplayReturnDetails={setDisplayReturnDetails}
          />
        </Box>
        <ParentSku
          selectedPart={selectedPart}
          displayNull={displayNull}
          eligibleRMA={eligibleRMA}
          parentSku={parentSku}
          showTabs={showTabs}
          isDesktop={isDesktop}
        />
        {!isDesktop && etaToShow}
        {!isDesktop && returnStatusData && (
          <ReturnStatus
            returnStatusData={returnStatusData}
            orderDetails={orderInfo}
            Link={Link}
            creditStatus={creditStatus}
            returnRequestStatus={returnRequestStatus}
            setReturnDetailsData={setReturnDetailsData}
            setDisplayReturnDetails={setDisplayReturnDetails}
            isDesktop={isDesktop}
          />
        )}
      </Box>
      <DisplayVideoLightBox
        displayNull={displayNull}
        isBot={isBot}
        showVideo={showVideo}
        setShowVideo={setShowVideo}
        productText={productText}
        partsWithVideos={partsWithVideos}
        selectedPart={selectedPart}
      />
    </>
  )
}

export default RMAReturnItemInfo
